<div class="media">
	<a [routerLink]="[routerLinkUrl]" [queryParams]="{itm: product?.id}" class="product-image-container">
		<img class="img-fluid product-image" *ngIf="primaryImage" [attr.src]="primaryImage"
			style="max-width: 100%;max-height: 100%" onError="this.src='assets/images/img-not-available.png';"
			class="image-center">
		<img class="img-fluid product-image-hover" *ngIf="secondaryImage" [attr.src]="secondaryImage"
			style="max-width: 100%;max-height: 100%" onError="this.src='assets/images/img-not-available.png';"
			class="image-center">
	</a>
	<div class="media-body product-box-vertical">
		<div class="rating">
			<bar-rating [rate]="product?.ratingInfo?.rating" [theme]="'default'"
            (rateChange)="updateRating($event)"></bar-rating>
		</div>
		<a [routerLink]="[routerLinkUrl]" [queryParams]="{itm: product?.id}">
			<p class="product-detail-new--h6">{{product.name}}</p>
		</a>
		<div class="sale-percentage" *ngIf="product?.sale_price_percentage">
			- {{ product?.sale_price_percentage }} %
		  </div>
		<ng-container *ngIf="company && !company?.allCompanySettings?.shopPriceWithTax">
			<ng-container *ngIf="product?.sale_price_without_tax">
				<h4 class="product-detail-new--h4">
					{{product?.sale_price_without_tax?.amount | currency:product?.sale_price_without_tax?.currency:'symbol' : '1.0-2'}}
					<del>{{product.priceWithoutTax?.amount | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}</del>
				</h4>
				<div class="product-tax">+
					{{ product?.taxRate?.rate }}% <span i18n="@@Pdv">PDV</span>
				</div>
			</ng-container>
			<ng-container *ngIf="!product?.sale_price_without_tax">
				<h4 class="product-detail-new--h4">
					{{product?.priceWithoutTax?.amount | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2' }}
				</h4>
				<div class="product-tax">+
					{{ product?.taxRate?.rate }}% <span i18n="@@Pdv">PDV</span>
				</div>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="company && company?.allCompanySettings?.shopPriceWithTax">
			<ng-container *ngIf="product?.sale_price_without_tax">
				<h4 class="product-detail-new--h4">
					{{ (product?.sale_price_without_tax?.amount  * ((product?.taxRate?.rate / 100) + 1))  | currency:product?.sale_price_without_tax?.currency:'symbol' : '1.0-2' }}
					<del style="font-size: 14px;">{{(product.priceWithoutTax?.amount  * ((product?.taxRate?.rate / 100) + 1)) | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}</del>
				</h4>
			</ng-container>
			<ng-container *ngIf="!product?.sale_price_without_tax">
				<h4 class="product-detail-new--h4">
					{{  (product?.priceWithoutTax?.amount * ((product?.taxRate?.rate / 100) + 1))  | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}
				</h4>
			</ng-container>
		</ng-container>

		<ul class="color-variant" *ngIf="product.variants">
			<li [class]="variant.color" (click)="changeVariantImage(variant.images)"
				*ngFor="let variant of product.variants"></li>
		</ul>
	</div>
</div>